import type { ReactNode } from 'react';
import { NavLink } from 'react-router';
import { Wordmark } from './Wordmark';
import { Toasts } from './Toasts';
import { useAuth, initials } from '../store/authStore';

const links: Array<[string, string]> = [['/', 'Play'], ['/drones', 'Drones'], ['/gallery', 'Gallery'], ['/about', 'About'], ['/credits', 'Credits']];

export function PageShell({ title, eyebrow, actions, children }: { title?: string; eyebrow?: string; actions?: ReactNode; children: ReactNode }) {
  const user = useAuth((s) => s.user);
  return (
    <div className="page">
      <div className="page__inner">
        <header className="page__nav">
          <Wordmark to="/" />
          <nav aria-label="Site">
            {links.map(([to, label]) => (
              <NavLink key={to} to={to} end={to === '/'} className={({ isActive }) => `btn btn--sm btn--ghost${isActive ? ' is-on' : ''}`}>{label}</NavLink>
            ))}
            {user
              ? <NavLink to="/auth" className="avatar is-in" title={user.email} aria-label={`Account: ${user.email}`}>{initials(user.email)}</NavLink>
              : <NavLink to="/auth" className="btn btn--sm">Sign in</NavLink>}
          </nav>
        </header>
        {(title || actions) && (
          <div className="page__head">
            <div>
              {eyebrow && <div className="eyebrow">{eyebrow}</div>}
              {title && <h1>{title}</h1>}
            </div>
            {actions && <div className="row">{actions}</div>}
          </div>
        )}
        {children}
      </div>
      <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none' }}><Toasts /></div>
    </div>
  );
}
